import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";
import { RECORDING_ANNOUNCEMENTS } from "@/react/features/support-tools/extensions/constants";

const schema = yup.object({
  subscriptionId: yup.string().nullable(),
  extensionNumber: yup.string().nullable(),
  callerIdFirstName: yup.string().nullable(),
  callerIdLastName: yup.string().nullable(),
  allowOverLimit: yup.boolean().nullable(),
  mode: yup.string().nullable(),
  recordingAnnouncement: yup
    .string()
    .oneOf(Object.keys(RECORDING_ANNOUNCEMENTS))
    .nullable(),
});

addKeyToFieldsRecursively(schema);

export default schema;
